import ConstructorIO from '@constructor-io/constructorio-client-javascript';
import { constructorInstance } from './constructor-instance';
import { constructorToBrand, ConstructorGroups, ConstructorReturnObject } from './util';
import { IBrowseParameters } from '@constructor-io/constructorio-client-javascript/lib/types/browse';

export async function getBrandsFromDealIds(
    ids: string[],
    defaultFilters: IBrowseParameters = {},
    constructor: ConstructorIO = constructorInstance
) {
    const result = await constructor.browse.getBrowseResults(
        'group_id',
        ConstructorGroups.CustomerCategories,
        {
            resultsPerPage: defaultFilters.resultsPerPage,
            filters: {
                ...(defaultFilters?.filters || {}),
                AffiliateBrandId: ids,
            },
        }
    );

    const results = (result.response?.results ?? []) as ConstructorReturnObject[];
    return constructorToBrand(results);
}
